import { render, staticRenderFns } from "./InputSelected.vue?vue&type=template&id=445aa196&scoped=true"
import script from "./InputSelected.vue?vue&type=script&lang=ts"
export * from "./InputSelected.vue?vue&type=script&lang=ts"
import style0 from "./InputSelected.vue?vue&type=style&index=0&id=445aa196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445aa196",
  null
  
)

export default component.exports